import { Routes } from '@angular/router';

export const CUSTOM_REDIRECTS: Routes = [
  {
    path: 'help',
    pathMatch: 'full',
    redirectTo: 'faqs'
  },
  {
    path: 'blog',
    pathMatch: 'full',
    redirectTo: ''
  },
  {
    path: 'contact',
    pathMatch: 'full',
    redirectTo: 'about-us'
  },
  {
    path: 'register-for-free-trial',
    pathMatch: 'full',
    redirectTo: 'register'
  },
  {
    path: 'member/forgot_password',
    pathMatch: 'full',
    redirectTo: 'identity'
  }
];
